import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  paddingRight: '20px',
}));

export const MaxWidthContainer = styled(Box)(() => ({
  maxWidth: '2000px',
  width: '100%',
}));
